module.exports = __webpack_public_path__ + "img/succ-2.86143370.png";